import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'flex.css/dist/data-flex.css'
import '@/assets/css/custom.styl'

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

Vue.use(require('vue-wechat-title'))

import eventHub from '@/lib/eventHub'
Vue.prototype.$eventHub = eventHub;

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
